function getComponentPropertiesFrom(input) {

	const byEqualOrColon = /=|:/g;
	const [, id, prop] = input.split(byEqualOrColon);

	return { id, prop };
}

export function getModelFromInput(input, model, checkRetrocompatibility = false) {
	if (!input) {
		return false;
	}

	let { id, prop } = getComponentPropertiesFrom(input);

	if (checkRetrocompatibility && !isNaN(prop)) {
		prop = "value";
	}

	const cannotAccessProperties = !id || !prop || !model[id] || !(prop in model[id]);
	if (cannotAccessProperties) {
		return false;
	}

	return model[id][prop];
}

export function getModelFromInputAtPosition(model, inputs, position) {
	if (!Array.isArray(inputs) || inputs.length <= position) {
		return false;
	}

	const input = inputs[position];
	return getModelFromInput(input, model);
}
